import React, { useEffect, useRef } from "react";

const Popup = ({ title,text, setShowPopup }) => {

  const popupRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowPopup]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-20">
      <div
        ref={popupRef}
        className=" w-[90%] xl:w-[70%] bg-white p-[6vw] xl:p-[3vw] rounded-lg shadow-lg text-center"
      >
        {/* <p className="text-[4vw] xl:text-[1.5vw] font-redhatMedium text-gray-700">
          {text}
        </p> */}
        <h2 className="font-redhatMedium text-[3.5vw] md:text-[2vw] xl:text-[1.5vw] text-left py-[0.8vw] xl:py-[0.5vw] mb-[2vw] xl:mb-[1vw] border-b border-primary">{title}</h2>
        <div
          className="prose max-w-none font-redhatRegular leading-relaxed text-left space-y-2 text-[3.5vw] md:text-[2.5vw] xl:text-[1.2vw]" // optional Tailwind class for clean typography
          dangerouslySetInnerHTML={{ __html: text }}
        />
        <button
          onClick={() => setShowPopup(false)}
          className="mt-[3vw] px-[2.5vw] xl:px-[1vw] py-[1.5vw] xl:py-[0.5vw] bg-blue-600 text-white rounded"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default Popup;
